import { render, staticRenderFns } from "./WizardPageKeyLabel.vue?vue&type=template&id=b6ff0358&scoped=true&"
import script from "./WizardPageKeyLabel.vue?vue&type=script&lang=ts&"
export * from "./WizardPageKeyLabel.vue?vue&type=script&lang=ts&"
import style0 from "./WizardPageKeyLabel.vue?vue&type=style&index=0&id=b6ff0358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ff0358",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
